module.exports = __webpack_public_path__ + "static/media/008_Acolor panel.cce608db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/farmers/008_Acolor panel.png
// module id = 419
// module chunks = 0